export function isNavigationDivider(item: NavigationItem): item is NavigationDivider {
  return 'divider' in item && item.divider;
}

export function isNavigationSubmenu(item: NavigationItem): item is NavigationSubmenu {
  return 'items' in item && !!item.items;
}

export function isNavigationLink(item: NavigationItem): item is NavigationLink {
  return !isNavigationSubmenu(item) && !isNavigationDivider(item);
}
